function u() {
  return typeof window < "u";
}
function a(t) {
  return m(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function r(t) {
  var n;
  return (t == null || (n = t.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function S(t) {
  var n;
  return (n = (m(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : n.documentElement;
}
function m(t) {
  return u() ? t instanceof Node || t instanceof r(t).Node : !1;
}
function D(t) {
  return u() ? t instanceof Element || t instanceof r(t).Element : !1;
}
function E(t) {
  return u() ? t instanceof HTMLElement || t instanceof r(t).HTMLElement : !1;
}
function l(t) {
  return !u() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof r(t).ShadowRoot;
}
function w(t) {
  const {
    overflow: n,
    overflowX: o,
    overflowY: i,
    display: e
  } = g(t);
  return /auto|scroll|overlay|hidden|clip/.test(n + i + o) && e !== "inline" && e !== "contents";
}
let f;
function v() {
  return f == null && (f = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), f;
}
function b(t) {
  return /^(html|body|#document)$/.test(a(t));
}
function g(t) {
  return r(t).getComputedStyle(t);
}
function N(t) {
  if (a(t) === "html")
    return t;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    l(t) && t.host || // Fallback.
    S(t)
  );
  return l(n) ? n.host : n;
}
function p(t) {
  const n = N(t);
  return b(n) ? t.ownerDocument ? t.ownerDocument.body : t.body : E(n) && w(n) ? n : p(n);
}
function d(t, n, o) {
  var i;
  n === void 0 && (n = []), o === void 0 && (o = !0);
  const e = p(t), y = e === ((i = t.ownerDocument) == null ? void 0 : i.body), c = r(e);
  if (y) {
    const s = h(c);
    return n.concat(c, c.visualViewport || [], w(e) ? e : [], s && o ? d(s) : []);
  } else
    return n.concat(e, d(e, [], o));
}
function h(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
export {
  g as getComputedStyle,
  S as getDocumentElement,
  h as getFrameElement,
  p as getNearestOverflowAncestor,
  a as getNodeName,
  d as getOverflowAncestors,
  N as getParentNode,
  r as getWindow,
  D as isElement,
  E as isHTMLElement,
  b as isLastTraversableNode,
  m as isNode,
  w as isOverflowElement,
  l as isShadowRoot,
  v as isWebKit
};
